module.exports = __webpack_public_path__ + "img/olea.c0cc5b0e.jpg";